import { useReducer, useEffect } from 'react';
import { getContactDetails } from '../services/Contacts';

const contactEventsReducer = (state, action) => ({
  contactEvents: state.contactEvents.concat(action.contactEvents),
});

const useContactEvents = () => {
  const [state, dispatch] = useReducer(contactEventsReducer, { contactEvents: [] });

  useEffect(() => {
    const contacts = window.connect.contact((contact) => {
      const newEvents = [];
      const timestamp = new Date();

      const contactDetails = getContactDetails(contact);

      newEvents.push(`New contact with ID ${contactDetails.contactId}`);
      newEvents.push(`Contact is from the ${contactDetails.queueName} queue`);
      newEvents.push(contactDetails.phone
        ? `New call is from ${contactDetails.phone}`
        : 'This is an existing contact for this agent');
      newEvents.push('New call offered. Subscribing to events for the call');

      dispatch({ contactEvents: newEvents.map(e => ({ timestamp, message: e })) });
    });

    return () => contacts.unsubscribe();
  }, []);

  return state.contactEvents;
};

export default useContactEvents;
